import styles from "./CompleteIcon.module.css";
import CompleteIconSVG from "./Complete_Icon.svg";

/**
 * View Component. Displays a checkmark icon when the voting result is complete
 */
export function CompleteIcon() {
  return (
    <img
      src={CompleteIconSVG}
      className={styles.img}
      alt="Voting Result is Complete"
    />
  );
}

CompleteIcon.propTypes = {};
